import { UserApiModel } from 'app/models/user-api.model';
import * as userActions from '@core/auth/@store/user/user.actions';
import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions/users.actions';

export interface State {
  users: UserApiModel[];
  isUsersLoading: boolean;
  isReady: boolean;
}

export const initialState: State = {
  users: [],
  isUsersLoading: false,
  isReady: false,
};

export const featureReducer = createReducer(
  initialState,
  on(actions.loadUsersSuccess, (state: State, { items }) => ({
    ...state,
    isUsersLoading: false,
    isReady: true,
    users: items,
  })),
  on(actions.loadUsers, (state: State) => ({
    ...state,
    isUsersLoading: true,
    isReady: false,
  })),
  on(userActions.setActiveCompany, actions.resetUsers, () => initialState)
);

export function reducer(state: State | undefined, action: Action): State {
  return featureReducer(state, action);
}
